import { useState, useEffect } from 'react'
import { toast } from 'react-toastify'

export const useFetchAllVehicleCredits = ({marvarApi, dispatch, onLogout}) => {
    const [vehicleCredits, setVehicleCredits] = useState([])
    
    const [ execute, setExecute ] = useState(false)
    const executeFetchAllVehicleCredits = async () => {
        setExecute(!execute)
    }

    const fetchData = async () => {
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())

        try {
            const response = await marvarApi.get(`/vehicle/legal-credits/all-credits`)
            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
        fetchData()
            .then((resp) => {
                setVehicleCredits(resp.data)
            })
            .catch(e => {
                console.log(e, '________ERROR')
            })
    }, [execute])

    return { vehicleCredits, executeFetchAllVehicleCredits }

}

export const useFetchAllVehicles = ({marvarApi, dispatch, onLogout, Forms}) =>{

    const {FormRequestGlobal:{formState}} = Forms

    // 1. Para almacenar los clientes
    const [vehicles, setVehicles] = useState([])


    // 2. Para ejecutar el fetch desde alguna acción
    const [ execute, setExecute ] = useState(false)
    const executeFetchAllVehicles = async () => {
        setExecute(!execute)
    }

    const fetchData = async () => {
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())
        try {
            const response = await marvarApi.get(`/vehicle/common/get-vehicles/${formState.idvehiculo}`)
            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
        if(formState.idvehiculo>0){
            fetchData()
                .then((resp) => {
                    const { data } = resp
                    setVehicles(data)
                })
                .catch(e => {
                    console.log(e, '________ERROR')
                })
        }

    }, [execute])

    return { vehicles, executeFetchAllVehicles }
}

export const useFetchAllCustomers = ({marvarApi, dispatch, onLogout}) =>{

    // 1. Para almacenar los clientes
    const [customers, setCustomers] = useState([])


    // 2. Para ejecutar el fetch desde alguna acción
    const [ execute, setExecute ] = useState(false)
    const executeFetchAllCustomers = async () => {
        setExecute(!execute)
    }

    const fetchData = async () => {
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())
        try {
            const response = await marvarApi.get(`/leases/common/get-customers`)
            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
            fetchData()
                .then((resp) => {
                    
                    // Setea en el estado del formulario los datos del registro
                    const { data } = resp
                    
                    setCustomers(data)
                })
                .catch(e => {
                    console.log(e, '________ERROR')
                })
    }, [execute])

    return { customers, executeFetchAllCustomers }
}

export const useFetchInfoCredit = ({marvarApi, dispatch, onLogout, Forms}) =>{
    const { FormRequestGlobal } = Forms
    const { formState, setFormState } = FormRequestGlobal

    // 2. Para mostrar animación de carga
    const [ loadingFetchInfoApplication, setLoadingFetchInfoApplication ] = useState(false)

    // 4. Para ejecutar el fetch desde alguna acción
    const [ execute, setExecute ] = useState(false)
    const executeFetchInfoCredit = async () => {
        setExecute(!execute)
    }

    const fetchData = async () => {
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())
        try {
            const response = await marvarApi.get(`/vehicle/common/get-application-ID/${formState.idcredito}`)
            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
        if(formState.idcredito > 0 ){
            setLoadingFetchInfoApplication(true)
            fetchData()
                .then((resp) => {
                    
                    // Setea en el estado del formulario los datos del registro
                    const { data } = resp
                    
                    setFormState((prevState) => ({
                        ...prevState,
                        idvehiculo: data.idvehiculo || 0,
                        idcliente: data.idcliente || 0,
                        idcotizacion: data.idcotizacion || 0,
                        credito_fecha: data.credito_fecha || '',
                        credito_dia_pago: data.credito_dia_pago || '',
                        vigencia_check: data.vigencia_check || '',
                        vigencia_fecha: data.vigencia_fecha || '',
                        
                    }))
                    setLoadingFetchInfoApplication(false)
                })
                .catch(e => {
                    console.log(e, '________ERROR')
                    setLoadingFetchInfoApplication(false)
                })
        }
    }, [execute, formState.idcredito])

    return { loadingFetchInfoApplication, executeFetchInfoCredit }
}

export const useFetchInfoQuote = ({marvarApi, dispatch, onLogout, Forms, Helpers}) =>{
    const { FormRequestGlobal } = Forms
    const { formState, setFormState } = FormRequestGlobal

    const {numberFormatter} = Helpers

    // 2. Para mostrar animación de carga
    const [ loadingFetchInfoQuote, setLoadingFetchInfoQuote ] = useState(false)

    // 4. Para ejecutar el fetch desde alguna acción
    const [ execute, setExecute ] = useState(false)
    const executeFetchInfoQuote = async () => {
        setExecute(!execute)
    }

    const fetchData = async () => {
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())
        try {
            const response = await marvarApi.get(`/vehicle/common/get-quotes-ID/${formState.idcotizacion}`)
            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
        if(formState.idcotizacion > 0 ){
            setLoadingFetchInfoQuote(true)
            fetchData()
                .then((resp) => {
                    
                    // Setea en el estado del formulario los datos del registro
                    const { data } = resp
                    setFormState((prevState) => ({
                        ...prevState,
                        idcotizacion: data.idcotizacion || 0,
                        enganche: data.enganche || '',
                        interes_total: data.interes_total || '',
                        interes: (data.interes*100) || '',
                        plazo: data.plazo || '',
                        plazo_anios: data.plazo_anios || '',

                        monto_venta: numberFormatter.format(data.monto_venta) || '',
                        saldo_financiar: numberFormatter.format(data.saldo_financiar) || '',
                        monto_enganche: numberFormatter.format(data.monto_enganche) || '',
                        gps: numberFormatter.format(data.gps) || '',
                        seguro: numberFormatter.format(data.seguro) || '',
                        otros: numberFormatter.format(data.otros) || '',
                        total_cuota: numberFormatter.format(data.total_cuota) || '',
                        cuota_niv: numberFormatter.format(data.cuota_niv) || ''
                    }))
                    setLoadingFetchInfoQuote(false)
                })
                .catch(e => {
                    console.log(e, '________ERROR')
                    setLoadingFetchInfoQuote(false)
                })
        }
    }, [execute])

    return { loadingFetchInfoQuote, executeFetchInfoQuote }
}

export const useFetchAllQuotes = ({marvarApi, dispatch, onLogout, Forms}) =>{

    const {FormRequestGlobal:{formState}} = Forms

    // 1. Para almacenar los clientes
    const [quotes, setQuotes] = useState([])


    // 2. Para ejecutar el fetch desde alguna acción
    const [ execute, setExecute ] = useState(false)
    const executeFetchAllQuotes = async () => {
        setExecute(!execute)
    }

    const fetchData = async () => {
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())
        try {
            const response = await marvarApi.get(`/vehicle/common/get-quotes/${formState.idcotizacion}`)
            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
        if(formState.idcotizacion>0){
            fetchData()
                .then((resp) => {
                    // Setea en el estado del formulario los datos del registro
                    const { data } = resp
                    setQuotes(data)
                })
                .catch(e => {
                    console.log(e, '________ERROR')
                })
        }

    }, [execute])

    return { quotes, executeFetchAllQuotes }
}

export const useFetchAllFiles = ({marvarApi, dispatch, onLogout, Forms}) =>{
    const { FormRequestGlobal:{formState, setFormState} } = Forms

    // 1. Para mostrar animación de carga
    const [ loadingFetchInfoFiles, setLoadingFetchInfoFiles ] = useState(false)

    // 4. Para ejecutar el fetch desde alguna acción
    const [ execute, setExecute ] = useState(0)
    const executeFetchAllFiles = async () => {
        setExecute(currentCount => currentCount + 1)
    }

    const fetchData = async () => {
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())
        try {
            const response = await marvarApi.get(`/vehicle/common/get-documents/${formState.idcredito}`)
            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
        if(formState.idcredito > 0 ){
            setLoadingFetchInfoFiles(true)
            fetchData()
                .then((resp) => {
                    
                    // Setea en el estado del formulario los datos del registro
                    const { data } = resp

                    setFormState((prevState) => ({
                        ...prevState,
                        files: data
                    }))

                    setLoadingFetchInfoFiles(false)

                })
                .catch(e => {
                    console.log(e, '________ERROR')
                    setLoadingFetchInfoFiles(false)
                })
        }
    }, [execute])

    return {loadingFetchInfoFiles, executeFetchAllFiles }
}

export const useFetchAllDeposits= ({marvarApi, dispatch, onLogout, Forms}) => {

    const [deposits, setDeposits] = useState([])
    const [loadingFetchDeposits, seteLoadingFetchDeposits ] = useState(false) //estado para animacion de carga
    
    const {FormRequestGlobal:{formState}} = Forms

    const [ execute, setExecute ] = useState(false)
    const executeFetchAllDeposits = async () => {
        setExecute(!execute)
    }

    const fetchData = async () => {
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())

        try {
            const response = await marvarApi.get(`/vehicle/common/get-deposit/${formState.idcredito}`)
            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
        if(formState.idcredito > 0 ){
            seteLoadingFetchDeposits(true)
            fetchData()
                .then((resp) => {
                    setDeposits(resp.data)
                    seteLoadingFetchDeposits(false)
                })
                .catch(e => {
                    console.log(e, '________ERROR')
                    seteLoadingFetchDeposits(false)
                })
        }
    }, [execute])

    return { deposits, loadingFetchDeposits, executeFetchAllDeposits }
}

export const useFetchInfoDeposit = ({marvarApi, dispatch, onLogout, Forms, Helpers}) =>{
    const { FormDeposit:{setFormState} } = Forms

    const {numberFormatter} = Helpers

    // 1. Para setear parametros de búsqueda al fetch
    const [paramsToSearch, setParamsToSearch] = useState({})

    // 2. Para ejecutar el fetch desde alguna acción
    const [ execute, setExecute ] = useState(false)
    const executeFetchInfoDeposit = async () => {
        setExecute(!execute)
    }

    const fetchData = async () => {
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())
        try {
            const response = await marvarApi.get(`/vehicle/common/get-deposit-by-ID/${paramsToSearch.iddeposit}`)
            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
        if(paramsToSearch.iddeposit > 0 ){
            fetchData()
                .then((resp) => {
                    
                    // Setea en el estado del formulario los datos del registro
                    const { data } = resp
                    setFormState((prevState) => ({
                        ...prevState,
                        iddeposit: data.iddeposit || '',
                        idcaja : data.idcaja || '',
                        idbanco : data.idbanco || '',
                        boleta_numero : data.boleta_numero || '',
                        boleta_foto_path : data.boleta_foto_path || '',
                        boleta_foto_originalname : data.boleta_foto_originalname || '',
                        aprobacion_referencia_ach : data.aprobacion_referencia_ach || '',
                        aprobacion_observaciones : data.aprobacion_observaciones || '',
                        aprobacion_check : data.aprobacion_check || '',
                        deposito_fecha : data.deposito_fecha || '',
                        deposito_moneda : data.deposito_moneda || '',
                        deposito_observaciones : data.deposito_observaciones || '',
                        deposito_tipo_cambio : data.deposito_tipo_cambio || '',
                        movimiento_tipo : data.movimiento_tipo || '',
                        
                        deposito_dolares : numberFormatter.format(data.deposito_dolares) || '',
                        deposito_monto : numberFormatter.format(data.deposito_monto) || '',
                        deposito_quetzales : numberFormatter.format(data.deposito_quetzal) || '',
                    }))

                })
                .catch(e => {
                    console.log(e, '________ERROR')
                })
        }
    }, [execute])

    return { setParamsToSearch, executeFetchInfoDeposit }
}

export const useFetchAllCashRegisters= ({marvarApi, dispatch, onLogout}) => {
    const [cashRegisters, setCashRegisters] = useState([])
    

    const [ execute, setExecute ] = useState(false)
    const executeFetchAllCashRegisters = async () => {
        setExecute(!execute)
    }

    const fetchData = async () => {
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())

        try {
            const response = await marvarApi.get(`/caja`)
            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
            fetchData()
                .then((resp) => {
                    const { data } = resp
                    setCashRegisters(data)
                })
                .catch(e => {
                    console.log(e, '________ERROR')
                })
    }, [execute])

    return { cashRegisters, executeFetchAllCashRegisters }
}

export const useFetchAllBanks= ({marvarApi, dispatch, onLogout}) => {
    const [banks, setBanks] = useState([])
    

    const [ execute, setExecute ] = useState(false)
    const executeFetchAllBanks = async () => {
        setExecute(!execute)
    }

    const fetchData = async () => {
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())

        try {
            const response = await marvarApi.get(`/banco`)
            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
            fetchData()
                .then((resp) => {
                    const { data } = resp

                    setBanks(data)

                })
                .catch(e => {
                    console.log(e, '________ERROR')
                })
    }, [execute])

    return { banks, executeFetchAllBanks }
}

export const useFetchAllPreInventory = ({marvarApi, dispatch, onLogout, Forms}) =>{
    const { FormPreInvventory:{setFormState}, FormRequestGlobal:{formState}} = Forms

    // 1. Para mostrar animación de carga
    const [ loadingFetchPreInventory, setLoadingFetchPreInventory ] = useState(false)

    const [preInventory, setPreInventory] = useState([])

    // 4. Para ejecutar el fetch desde alguna acción
    const [ execute, setExecute ] = useState(0)
    const executeFetchAllPreInventory = async () => {
        setExecute(currentCount => currentCount + 1)
    }

    const fetchData = async () => {
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())
        try {
            const response = await marvarApi.get(`/vehicle/common/get-preinventory/${formState.idcredito}`)
            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
        if(formState.idcredito > 0 ){
            setLoadingFetchPreInventory(true)
            fetchData()
                .then((resp) => {
                    
                    // Setea en el estado del formulario los datos del registro
                    setPreInventory(resp.data)
                    setLoadingFetchPreInventory(false)

                })
                .catch(e => { 
                    console.log(e, '________ERROR')
                    setLoadingFetchPreInventory(false)
                })
        }
    }, [execute, formState.idcredito])

    return {preInventory, loadingFetchPreInventory, executeFetchAllPreInventory }
}

export const useFetchInfoPreInventory = ({marvarApi, dispatch, onLogout, Forms, Helpers}) =>{
    const { FormPreInvventory:{setFormState } } = Forms

    const {numberFormatter}= Helpers
    const [paramsToSearch, setParamsToSearch] = useState({})

    // 2. Para mostrar animación de carga
    const [ loadingFetchPreInventory, setLoadingFetchPreInventory ] = useState(false)

    // 4. Para ejecutar el fetch desde alguna acción
    const [ execute, setExecute ] = useState(false)
    const executeFetchPreInventory = async () => {
        setExecute(!execute)
    }

    const fetchData = async () => {
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())
        try {
            const response = await marvarApi.get(`/vehicle/common/get-preinventory-ID/${paramsToSearch.idvehicledeposit}`)
            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
        if(paramsToSearch.idvehicledeposit > 0 ){
            setLoadingFetchPreInventory(true)
            fetchData()
                .then((resp) => {

                    // Setea en el estado del formulario los datos del registro
                    const { data } = resp
                    setFormState((prevState) => ({
                        ...prevState,
                        idvehicledeposit: data.idvehicledeposit || 0,
                        valor: numberFormatter.format(data.valor) || '',
                        marca: data.marca || '',
                        modelo: data.modelo || '',
                        linea: data.linea || '',
                        color: data.color || '',
                        matricula: data.matricula || '',
                        chasis: data.chasis || ''
                    }))
                    setLoadingFetchPreInventory(false)
                })
                .catch(e => {
                    console.log(e, '________ERROR')
                    setLoadingFetchPreInventory(false)
                })
        }
    }, [execute])

    return { setParamsToSearch, loadingFetchPreInventory, executeFetchPreInventory }
}

export const useFetchInfoLogBook = ({marvarApi, dispatch, onLogout, Forms}) => {

    const {FormRequestGlobal:{formState}} = Forms

    const [observations, setObservations] = useState([])
    
    const [ execute, setExecute ] = useState(false)
    const executeFetchInfoLogBook = async () => {
        setExecute(!execute)
    }

    const fetchData = async () => {
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())
        if (formState.idcredito > 0) {
            try {
                const response = await marvarApi.get(`/vehicle/legal-credits/get-all-entries/${formState.idcredito}`)
                return response.data
            } catch (e) {
                console.log(e)
            }
        }

    }

    useEffect(() => {
        if (formState.idcredito > 0) {
            fetchData()
                .then((resp) => {
                    setObservations(resp.data)
                })
                .catch(e => {
                    console.log(e, '________ERROR')
                })
        }
    }, [execute])

    return { observations, executeFetchInfoLogBook }

}

export const useFetchAllLegalExpenses = ({marvarApi, dispatch, onLogout, Forms}) => {
    const {FormRequestGlobal:{formState}} = Forms

    const [legalExpenses, setLegalExpenses] = useState([])
    
    const [ execute, setExecute ] = useState(false)
    const executeFetchAllLegalExpenses = async () => {
        setExecute(!execute)
    }

    const fetchData = async () => {
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())

        try {
            const response = await marvarApi.get(`/vehicle/common/all-legal-expenses/${formState.idcredito}`)
            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
        if(formState.idcredito>0){
            fetchData()
                .then((resp) => {
                    setLegalExpenses(resp.data)
                })
                .catch(e => {
                    console.log(e, '________ERROR')
                })
        }

    }, [execute])

    return { legalExpenses, executeFetchAllLegalExpenses }

}

export const useFetchDebtsSummary = ({marvarApi, dispatch, onLogout, Forms, Helpers}) =>{
    const { FormRequestGlobal } = Forms
    const { formState, setFormState } = FormRequestGlobal
    const {numberFormatter, getCurrentDate}= Helpers

    const fecha_actual = getCurrentDate()

    // 1. Para ejecutar el fetch desde alguna acción
    const [ execute, setExecute ] = useState(false)
    const executeFetchDebtsSummary = async () => {
        setExecute(!execute)
    }

    const fetchData = async () => {
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())
        try {
            const response = await marvarApi.post(`/vehicle/common/get-debts-summary/${formState.idcredito}`, {fecha_actual: fecha_actual})
            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
        if(formState.idcredito > 0 ){
            fetchData()
                .then((resp) => {
                    
                    // Setea en el estado del formulario los datos del registro
                    if(resp.title==='OK'){
                        const { rows } = resp
                        const total_deuda = parseFloat(rows[0].suma_total_pagar) + parseFloat(rows[0].total_gastos_juridicos)+ parseFloat(rows[0].total_gastos_admin)
                        
                        setFormState((prevState) => ({
                            ...prevState,
                            suma_dias_atraso_totales: rows[0].suma_dias_atraso_totales,
                            suma_total_pagar: numberFormatter.format(rows[0].suma_total_pagar),
                            total_gastos_juridicos: numberFormatter.format(rows[0].total_gastos_juridicos),
                            total_gastos_admin: numberFormatter.format(rows[0].total_gastos_admin),
                            total_deuda_credito: numberFormatter.format(total_deuda)
                        }))
                    }
                })
                .catch(e => {
                    console.log(e, '________ERROR')
                })
        }
    }, [execute])

    return { executeFetchDebtsSummary }
}


const alertMessage = (res, toggle) => {

    if (res) {
        const { title, message} = res
        if (title === 'OK') {
            toast.success(message, {
                position: "top-right",
                theme: "colored"
            })
            toggle && toggle()
        } else {
            toast.warn(message, {
                position: "top-right",
                theme: "colored",
                autoClose: false,
            })
        }
    } else {
        toast.warn('Error interno, notifique a Soporte técnico!.', {
            position: "top-right",
            theme: "colored",
            autoClose: false,
        })
    }
}



